import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import { API_ENDPOINTS } from "../../../../../../util/constants";

const initialListingsState = {
  listLoading: false,
  totalCount: 0,
  meta: {},
  entities: [],
  listingForEdit: undefined,
  lastError: null,
  queryParams: {},
  filters: {},
};
export const fetchAgentSettingsCSVLogsLists = createAsyncThunk(
  "agentSettingsCSVLogsListSlice/fetchAgentSettingsCSVLogsLists",
  async (paramsObj, { dispatch, rejectWithValue }) => {
    const { queryParams, type, topFilters } = paramsObj;
    const params = {};
    let url = `${API_ENDPOINTS.getAgentSettingCSVLogs}`;
    url  = url + "?operation=" + type;
    // params.limit = queryParams["pageSize"];
    // params.state = '2';
    // params.offset = (parseInt(queryParams["pageNumber"])-1) * parseInt(queryParams["pageSize"]);
    const response = await Axios.get(url, { params: { ...params } });
    const status  = response.status;
    try {
      if (status === 200) {
        return await response.data;
      } else {
        const error = {};
        error.message = "Can't find listings";
        return rejectWithValue({ error });
      }
    } catch (error) {
      return rejectWithValue({ error });
    }
  }
);

export const agentSettingsCSVLogsListSlice = createSlice({
  name: "agentSettingsCSVLogsListSlice",
  initialState: { ...initialListingsState },
  extraReducers: (builder) => {
    builder.addCase(fetchAgentSettingsCSVLogsLists.pending, (state, action) => {
      state.listLoading = true;
    });
    builder.addCase(fetchAgentSettingsCSVLogsLists.fulfilled, (state, action) => {
      const total_count = action?.payload?.meta?.total_count ? action?.payload?.meta?.total_count : 0 
      const entities = action.payload.data
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = total_count;
    });
    builder.addCase(fetchAgentSettingsCSVLogsLists.rejected, (state, action) => {
      // state.error = `${action.type}: ${action.error.message}`;
      state.listLoading = false;
    });
    builder.addCase("[Auth] Logout Action", (state, action) => {
      return { ...initialListingsState };
    });
  },
  reducers: {
    reset: (state, action) => {
      state.listLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
    },
    setFilters: (state, action) => {
      state.listLoading = false;
      if (action.payload["filters"]) {
        state.filters = { ...action.payload["filters"] };
      }
    },
  },
});
